<template>
  <div class="container">
    <div class="headImgs_box">
      <img
        class="headImgs"
        :src="require('../../assets/numberyuan/topbg.png')"
        alt=""
      />
    </div>

    <div class="content">
      <div class="firm_title_img">
        <img src="../../assets/numberyuan/titleimg.png" alt="" />
      </div>
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="left">
          <div>
            <img :src="item.imgIcon" alt="" />
            <span>{{ item.name }}</span>
          </div>
          <p>{{ item.loanText }}</p>
        </div>
        <div class="center">
          <div class="type">
            <div style="border-right: 1px solid #d5d5d5">
              可贷金额(万元)
              <span>{{ item.loanLimitFloor }}-{{ item.loanLimitCap }}</span>
            </div>
            <div style="border-right: 1px solid #d5d5d5">
              利率(%)
              <span v-if="item.interestRateFloor !== ''"
                >{{ item.interestRateFloor }}-{{ item.interestRateCap }}</span
              >
              <span v-else>限时优惠至0</span>
            </div>

            <div style="position: relative">
              <i style="font-style: initial">贷款(月)</i>
              <span>{{ item.minLoanTime }}-{{ item.maxLoanTime }}</span>
            </div>
          </div>
        </div>
        <div class="right">
          <img :src="item.qrCode" alt="" />
          <el-button type="primary" class="btn" @click="toDetail(item.id)"
            >立即申请
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseUrl from "../../api/baseUrl";
import {
} from "@/api/fangyi";
import Swiper from "swiper/js/swiper";

export default {
  components: {},
  data() {
    return {
      list: [
        {
          imgIcon: require("../../assets/numberyuan/bankicon3.png"),
          name: "助力金",
          id: "",
          loanLimitFloor: "1",
          loanLimitCap: "300",
          interestRateFloor: "",
          interestRateCap: "",
          minLoanTime: "0",
          maxLoanTime: "3",
          qrCode: require("../../assets/numberyuan/bankcode3.png"),
          loanText: "已成功放贷1824笔，放贷金额547.2万",
        },
        {
          imgIcon: require("../../assets/numberyuan/bankicon1.png"),
          name: "苏州e贷",
          id: "727a9d439bea4a12b02b84e6f18f2dc3",
          loanLimitFloor: "1",
          loanLimitCap: "300",
          interestRateFloor: "3.50",
          interestRateCap: "4.55",
          minLoanTime: "12",
          maxLoanTime: "36",
          qrCode: require("../../assets/numberyuan/bankcode4.png"),
          loanText: "已成功放贷12笔，放贷金额1560万",
        },
        {
          imgIcon: require("../../assets/numberyuan/bankicon1.png"),
          name: "普惠e贷",
          id: "6c0db707409349b981c5f65271df695d",
          loanLimitFloor: "1",
          loanLimitCap: "1000",
          interestRateFloor: "3.50",
          interestRateCap: "4.55",
          minLoanTime: "12",
          maxLoanTime: "36",
          qrCode: require("../../assets/numberyuan/bankcode5.png"),
          loanText: "已成功放贷25笔，放贷金额2070万",
        },
        {
          imgIcon: require("../../assets/numberyuan/bankicon1.png"),
          name: "苏数贷",
          id: "02490780617948f8872bed586763df5b",
          loanLimitFloor: "1",
          loanLimitCap: "2000",
          interestRateFloor: "3.50",
          interestRateCap: "4.55",
          minLoanTime: "12",
          maxLoanTime: "36",
          qrCode: require("../../assets/numberyuan/bankcode1.png"),
          loanText: "已成功放贷3笔，放贷金额900万",
        },
        {
          imgIcon: require("../../assets/numberyuan/bankicon2.png"),
          name: "善营贷",
          id: "f6aa4955889f4165a16514ae4214a2f9",
          loanLimitFloor: "1",
          loanLimitCap: "1000",
          interestRateFloor: "4.20",
          interestRateCap: "4.50",
          minLoanTime: "1",
          maxLoanTime: "36",
          qrCode: require("../../assets/numberyuan/bankcode2.png"),
          loanText: "已成功放贷90笔，授信放贷4947万",
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    getStyle(item) {
      return {
        backgroundImage: "url(" + baseUrl + item.background + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
      };
    },
    onSlideChange() {
      console.log("111");
    },
    gotochanpin() {
      this.$router.push("/xyd/fangyichanpin");
    },
    numberFormat(value) {
      let unit = "";
      var k = 10000,
        sizes = ["", "万", "亿", "万亿"],
        i;
      if (value < k) {
        value = value;
      } else {
        i = Math.floor(Math.log(value) / Math.log(k));
        value = (value / Math.pow(k, i)).toFixed(2);
        unit = sizes[i];
      }
      console.log(value);
      if (value && value !== "NaN") {
        return value + unit;
      } else {
        return "";
      }
    },
    toDetail(id) {
      console.log(11);
      if (id !== "") {
        this.$router.push("/xyd/product_list_details?id=" + id);
      }
    },
    swiper1() {
      new Swiper(this.$refs.mySwiper1, {
        slidesPerView: 4,
        slidesPerGroup: 4,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "my-button-disabled",
        },
      });
    },
  },
};
</script>

<style lang='less' scoped>
.container {
  position: relative;
  background-color: #fff;
  .headImgs_box {
    width: 100%;
    height: 567px;
    position: relative;
    .headImgs {
      width: 100%;
      height: 100%;
    }
    .text {
      width: 800px;
      position: absolute;
      top: 270px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      color: #fadec4;
      font-size: 23px;
      text-shadow: 0px 0px 1px rgb(207, 193, 193);
      // text-shadow: 3px 5px 3px rgb(104, 101, 101);
    }
  }

  .onekey_box {
    width: 1280px;
    // height: 300px;
    box-sizing: border-box;
    padding: 0 20px;
    padding-bottom: 30px;
    background: #ffecec;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    margin: 0 auto;
    position: relative;
    top: -250px;
    > img {
      width: 100%;
    }
    .brand_box {
      width: 100%;
      padding: 10px 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      .swiper-button-prev {
        color: red;
      }
      .swiper-button-next {
        color: red;
      }
      .item {
        width: 320px;
        height: 435px;
        box-sizing: border-box;
        text-align: left;
        background-color: #fff;
        border: 1px solid #d5d5d5;
        margin: 0 10px;
        margin-top: 30px;
        margin-bottom: 20px;
        cursor: pointer;
        position: relative;
        .logo_box {
          width: 100%;
          height: 80px;
          line-height: 90px;
          background-image: url(../../assets/fangyi/bankingtitlebg.png);
          background-size: 100% 100%;
          text-align: center;
          img {
            font-size: 0;
            width: 150px;
            //   height: 28px;
          }
        }
        .title_name {
          text-align: center;
          font-size: 23px;
        }
        .ed_info {
          display: flex;
          justify-content: space-around;
          div {
            width: 200px;
            text-align: center;
            //   padding: 0 35px;
            h1 {
              margin: 0;
              font-size: 22px;
            }
            span {
              display: block;
              color: #595858;
              position: relative;
              left: 5px;
            }
          }
        }
        .info {
          display: flex;
          justify-content: space-around;
          margin-top: 30px;
          div {
            width: 200px;
            text-align: center;
            //   padding: 0 35px;
            h1 {
              margin: 0;
              color: #000;
              font-size: 20px;
            }
            span {
              display: block;
              color: #595858;
              font-size: 14px;
              position: relative;
              left: 5px;
            }
          }
        }
        .code_box {
          text-align: center;
          margin-bottom: 20px;
          margin-top: 20px;
          position: relative;
          // bottom: -10px;
          z-index: 20;
          img {
            width: 80px;
          }
        }
        .btn_box {
          width: 100%;
          height: 10px;
          background: #d01e16;
          margin-top: 35px;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          position: absolute;
          bottom: 0;
        }
      }
      /deep/.el-carousel__item {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: auto;
        margin-top: 20px;

        .item {
          width: 23%;
          box-sizing: border-box;
          text-align: left;
          background-color: #fff;
          border: 1px solid #d5d5d5;
          margin: 0 10px;
          cursor: pointer;
          position: relative;
          .logo_box {
            width: 100%;
            height: 80px;
            line-height: 90px;
            background-image: url(../../assets/fangyi/bankingtitlebg.png);
            background-size: 100% 100%;
            text-align: center;
            img {
              font-size: 0;
              //   width: 150px;
              //   height: 28px;
            }
          }
          .title_name {
            text-align: center;
            font-size: 23px;
          }
          .ed_info {
            display: flex;
            justify-content: space-around;
            div {
              width: 200px;
              text-align: center;
              //   padding: 0 35px;
              h1 {
                margin: 0;
                font-size: 22px;
              }
              span {
                display: block;
                color: #595858;
                position: relative;
                left: 5px;
              }
            }
          }
          .info {
            display: flex;
            justify-content: space-around;
            margin-top: 30px;
            div {
              width: 200px;
              text-align: center;
              //   padding: 0 35px;
              h1 {
                margin: 0;
                color: #000;
                font-size: 20px;
              }
              span {
                display: block;
                color: #595858;
                font-size: 14px;
                position: relative;
                left: 5px;
              }
            }
          }
          .code_box {
            text-align: center;
            margin-bottom: 20px;
            margin-top: 20px;
            position: relative;
            // bottom: -10px;
            z-index: 20;
            img {
              width: 120px;
            }
          }
          .btn_box {
            width: 100%;
            height: 10px;
            background: #d01e16;
            margin-top: 35px;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
  }
  .firm_title_img {
    width: 100%;
    text-align: center;
    margin: 20px 0 10px;
    img {
      width: 100%;
    }
  }
  .content {
    width: 100%;
    // height: 300px;
    box-sizing: border-box;
    padding: 0 20px;
    padding-bottom: 30px;
    // background: #ffecec;
    // box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    margin: 0 auto;
    position: relative;
    top: -250px;
    .item {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-image: url("../../assets/numberyuan/itembg.png");
      background-size: 100% 100%;
      margin-bottom: 30px;
      padding: 30px 45px;
      .left {
        width: 300px;
        > div {
          display: flex;
          align-items: center;
          span {
            font-size: 26px;
            margin-left: 8px;
            color: #2a2a2a;
          }
          img {
            width: 45px;
            height: 45px;
          }
        }

        p {
          color: #2a2a2a;
          font-size: 16px;
        }
      }
      .center {
        width: 700px;
        display: flex;
        justify-content: space-between;
        .type {
          display: flex;
          align-items: center;
          justify-content: space-between;
          div {
            align-items: center;
            width: 200px;
            display: flex;
            flex-direction: column;
            font-size: 16px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            color: #595858;
            span {
              font-size: 26px;
              font-family: Alibaba PuHuiTi;
              font-weight: bold;
              color: #b90c1c;
            }
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
        img {
          width: 90px;
          height: 90px;
          margin-right: 50px;
        }
        /deep/ .btn {
          background-color: #d01e16;
          border: none;
          z-index: 100;
        }
      }
    }
  }
}
</style>